import React from 'react'
import PropTypes from 'prop-types'
import BreadcrumbsLink from './BreadcrumbsLink'
import BreadcrumbsLabel from './BreadcrumbsLabel'

/**
 * A single breadcrumb item.
 */
export default function BreadcrumbsItem(props) {
  const Comp = props.href ? BreadcrumbsLink : BreadcrumbsLabel
  return (
    <li className="c-breadcrumbs__list-item">
      <Comp {...props} />
    </li>
  )
}

BreadcrumbsItem.propTypes = {
  href: PropTypes.string,
}

BreadcrumbsItem.defaultProps = {
  href: null,
}
